<template>
    <div class="question-nps">
        <div class="question-title">
            {{ survey.question }}
        </div>
        <div class="nps-select">
            <div class="nps-select__item" v-for="i in 11" v-bind:key="i" v-tap v-on:click="setValue(i-1)" :class="{ 'active' : inputValue == i-1}">{{ i-1 }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Survey',
        props: ['survey', 'response'],
        data() {
            return {
                inputValue: null,
                questionId: 18,
            };
        },
        methods: {
            setValue(i) {
                this.inputValue = i;
                this.$emit('valueChanged', this.inputValue, this.survey.id, 'nps');
            }
        },
        created() {

        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .question-title {
        font-size: 40px;
        display: block;
    }

    .question-nps{
        width: 85%;
    }

    .nps-select {
        box-shadow: 0 2px 4px 0 rgba(178, 178, 178, 0.50);
        display: flex;
        justify-content: space-between;
        background: white;
        border-radius: 4px;
        margin-top: 45px;
        overflow: hidden;
        width: 100%;

        &__item {
            border-right: 1px solid #dadada;
            padding: 25px 0px;
            width: 100%;
            font-size: 20px;
            font-weight: 600;
            transition: background-color .2s ease-in-out, color .2s linear;

            &.active {
                background: #58d463;
                color: white;
                border-right: 1px solid white;
            }

            &:nth-child(-n+7){
                &.active {
                    background: #e45266;
                }
            }

            &:nth-child(8),
            &:nth-child(9){
                &.active {
                    background: #52c9e4;
                }
            }

            &:last-child {
                border-right: none;
            }
        }
    }

</style>
